import React, { FC } from 'react'
import { GetServerSideProps } from 'next'
import { ComponentType } from '@sport1/types/web'
import TeamContext from '@/context/TeamContext'
import StandardLayout from '@/layouts/Standard'
import PageContentLayout from '@/layouts/Standard/PageContentLayout'
import { TeamPageProps } from '@/types/page'
import { PageNotFound } from '@/utils/errors/handleRejection'
import LoadMoreButton from '@/components/LoadMoreButton'
import useLayoutPagination from '@/hooks/useLayoutPagination'
import getTeamPageSerSideProps from '@/helpers/teamHelper'

const Index: FC<TeamPageProps> = ({ layoutData, navigation, team }) => {
    const hasContent = layoutData.components.filter(
        c => c.type === ComponentType.TOP_TEASER_CARD
    ).length

    const url = navigation.tag?.navigationItems?.find(n => n.value === 'web-team-highlights')?.url

    const { layout, hasNextPage, loadNext } = useLayoutPagination({
        tag: navigation?.tag,
        initialLayout: layoutData,
        initialPage: 0,
        url: hasContent ? url : undefined,
    })

    return (
        <StandardLayout navigation={navigation}>
            {layout ? (
                <TeamContext team={team}>
                    <PageContentLayout layoutData={layout} />
                    {hasNextPage ? (
                        <LoadMoreButton
                            text="Mehr Videos laden"
                            onPress={loadNext}
                            backgroundColor="pearl"
                            shouldTrack
                        />
                    ) : null}
                </TeamContext>
            ) : null}
        </StandardLayout>
    )
}

export const getServerSideProps: GetServerSideProps<TeamPageProps | PageNotFound> = async ctx => {
    const teamId = ctx.query.id as string
    const props = await getTeamPageSerSideProps({ context: ctx, teamId, widget: 'highlights' })
    if ('notFound' in props) {
        return props
    }
    return { props }
}

export default Index
